<script setup lang="ts">
import type { ScheduleEvent } from '~/types'

defineOptions({
  name: 'ScheduleEventsLiveBadge',
})

interface Props {
  scheduleEvent: ScheduleEvent.Model
}

const props = defineProps<Props>()

const {
  isLive,
  srId,
} = useScheduleEvent(props.scheduleEvent)

const { currentPeriodText } = useBoxScore(srId)
</script>

<template>
  <span
    v-if="isLive"
    class="schedule-event-live-badge"
  >{{ currentPeriodText || 'Live' }}</span>
</template>

<style scoped lang="scss">
.schedule-event-live-badge {
  @apply block text-[11px] bg-[#f11a1a] normal-case px-2 rounded-full text-white text-center;
  @apply before:content-[''] before:w-[4px] before:h-[4px] before:rounded-full before:bg-white before:inline-block before:align-middle before:mr-[4px] before:relative before:-top-[1px];
}
</style>
